import React from 'react'
import StaffManagementFeatureBox1 from './StaffManagement-feature-box1'
function StaffManagementfeature() {
    return (
        <>
            <StaffManagementFeatureBox1 />
        </>
    )
}

export default StaffManagementfeature